// extracted by mini-css-extract-plugin
export default {"section":"section___E9G3p"};